import {
  Button,
  FlexBox,
  ModalBody,
  ModalHead,
  Text,
} from '@dixa/lib-shared-habla';
import { ModalWrapper, useModal } from 'lib-knowledge-modal';

type RetranslationWarningModalProps = {
  title: string;
  body: string;
  onAccept: () => void;
};

export function RetranslationWarningModal({
  title,
  body,
  onAccept,
}: RetranslationWarningModalProps): JSX.Element {
  const { hideModal } = useModal();
  const retranslate = () => {
    onAccept();
    hideModal();
  };

  return (
    <ModalWrapper>
      <ModalHead title={title} onClose={hideModal}></ModalHead>
      <ModalBody>
        <Text.Paragraph>{body}</Text.Paragraph>
        <FlexBox
          justifyContent="flex-end"
          gap="100"
          style={{ marginTop: 'var(--dixa-size-spacer-200)' }}
        >
          <Button variant="tertiary" onClick={hideModal}>
            Cancel
          </Button>
          <Button onClick={retranslate} variant="danger">
            Translate
          </Button>
        </FlexBox>
      </ModalBody>
    </ModalWrapper>
  );
}
